/**
 * Version comparison (FSD 2.2.5 "Compare Versions"; report "Version Comparison").
 * The two version ids travel in the URL so a comparison can be shared.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_PERMISSIONS } from '@/modules/budget/permissions'

export const BUDGET_COMPARE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/versions/compare',
    name: 'budget-compare',
    component: () => import('@/modules/budget/compare/CompareView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetCompare',
      permission: BUDGET_PERMISSIONS.versionRead,
    },
  },
]

export interface CompareScope {
  a?: number | null
  b?: number | null
  companyId?: number | null
  fiscalYear?: number | null
}

export function compareRoute(scope: CompareScope = {}): string {
  const params = new URLSearchParams()
  for (const key of ['companyId', 'fiscalYear', 'a', 'b'] as const) {
    const value = scope[key]
    if (value !== undefined && value !== null) params.set(key, String(value))
  }
  const query = params.toString()
  return query === '' ? '/budget/versions/compare' : `/budget/versions/compare?${query}`
}
